// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__4SPyz","label":"styles_label__yLPjS","icon":"styles_icon__S11K1"};